import { Injectable } from '@angular/core';
import { UtilsService } from 'pumpcalc-core';

export const Errors={
  backingpump:"backingpump",
  backingpumpparallel:"backingpumpparallel",
  booster:"booster",
  drive:"drive",
  pumpsetname:"pumpsetname",
  boosters:'boosters',
  boosterparallel:'boosterparallel',
  pipe:'pipe',
  pipework:'pipework',
  initialfrequency:'initialfrequency',
  maxrotationalspeed:'maxrotationalspeed'
}

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  constructor(private utils:UtilsService) {}
  validate(pumpSet:any){}
  validBackingPump(pumpsetDetails:any,errors:any):boolean{
    let result = true;
    if(!pumpsetDetails.backingPumpId){errors[Errors.backingpump]="No Backing Pump selected";result=false;}
    if(pumpsetDetails.numberOfBackingPumpsInParallel<=0){errors[Errors.backingpumpparallel]="Must have greater than 0 Backing Pump in parallel";result=false;}
    return result;
  }

  validBooster(booster:any,errors:any):boolean{
    let result = true;
    if(booster.boosterId==null){errors[Errors.booster]="No Booster selected";result=false;}
    if(booster.boosterDetails.driveId==null){errors[Errors.drive]="No Drive selected";result=false;}
    if(booster.numberOfBoostersInParallel<=0){errors[Errors.boosterparallel]="Must have greater than 0 Boosters in parallel";result=false;}
    let pipeworkErrors=[];
    if(!this.validPipes(booster.pipework,pipeworkErrors)){
      errors[Errors.pipe]=pipeworkErrors;
      result=false;
    };
    if(booster.pipework.length<1){errors[Errors.pipework]="Must have at least one pipe";}
    return result;
  }

  validPumpSet(pumpSet:any,errors:any):boolean{
    let result=true;
    if(!(pumpSet.name && /[a-zA-Z]/.test(pumpSet.name))){
      errors[Errors.pumpsetname]="Provide a name for the pumpset";
      result=false;
    }
    if(!this.validBackingPump(pumpSet.pumpsetDetails,errors)){
      result=false;
    }
    pumpSet.pumpsetDetails.boosterLayersDetails.forEach((booster,index)=>{
      if(!errors[Errors.boosters]){errors[Errors.boosters]={}}
      let booosterErrors={};
      if(!this.validBooster(booster,booosterErrors)){errors[Errors.boosters][index]=booosterErrors;result=false;}
    });
    return result;
  }

  validPipes(pipes:any[], pipeWorkErrors:any[]): boolean {
    let validPipes = true;
    pipes.forEach(function (pipe, index) {
      let pipeErrors=[];
      let validPipe = this.validPipe(pipe,pipeErrors,index);
      pipeWorkErrors.push(...pipeErrors);
      validPipes = !validPipes ? validPipes : validPipe;
    }.bind(this))
    return validPipes;
  }

  validPipe(pipe,errors: any[], rowIndex): boolean {
      if((pipe.shapeSection == 0 || pipe.shapeSection == 1 || pipe.shapeSection == 2) && pipe.xDim1<=0){
        errors.push(this.pipeError(rowIndex,"xdim1","xDim1 must be greater than 0"));
      }
      if((pipe.shapeSection == 1 || pipe.shapeSection == 2) && pipe.xDim2<=0){
        errors.push(this.pipeError(rowIndex,"xdim2","xDim1 must be greater than 0"));
      }
      if(pipe.length<0){
        errors.push(this.pipeError(rowIndex,"length","length must be greater than or equal to 0"));
      }
      if(pipe.bends<0){
        errors.push(this.pipeError(rowIndex,"bends","bends must be greater than or equal to 0"));
      }
      if(pipe.parallel<=0){
        errors.push(this.pipeError(rowIndex,"parallel","parallel must be greater than 0"));
      }
      return errors.length==0;
  }

  pipeError(rowIndex, dataField, message) {
    return { rowIndex: rowIndex, message: message, dataField: dataField, level: 1 };
  }

  getError(errors,path:string[]){
    return this.utils.getValueForPath(errors,this.utils.path(path));
  }

}
